import React from 'react'
import ContactViewedListContainer from '../ContactViewedListContainer.jsx'
import { useSelector } from 'react-redux'

function ContactViewedList({ title }) {
    const { user } = useSelector((state) => state.user);

    return (
        <ContactViewedListContainer user={user} matches={user.contactViewed} title={title} />
    )
}

export default ContactViewedList